// @flow
import React, { Component, Fragment } from 'react';
import DisplayProductCards from 'containers/list/DisplayProductCards';
import DisplayTab from 'components/display/DisplayTab/DisplayTab';
import { Helmet } from 'react-helmet';
import type { ContextRouter } from 'react-router-dom';
import queryString from 'query-string';

type Props = {} & ContextRouter;

class Display extends Component<Props, State> {
  render() {
    const { location, match, history } = this.props;
    const { sort } = queryString.parse(location.search);
    const { category } = match.params;
    return (
      <Fragment>
        <Helmet>
          <title>상품 | 캐시바이</title>
          <meta
            name="description"
            content="캐시바이에 방금 등록된 따끈따끈한 상품들을 살펴보세요."
          />
        </Helmet>
        <DisplayTab sort={sort} />
        <DisplayProductCards category={category} sort={sort} />
      </Fragment>
    );
  }
}

export default Display;



// WEBPACK FOOTER //
// ./src/pages/Display.js